var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-buttons"},[_c('div',{class:{
      'text-buttons__wrap': true,
      'text-buttons__wrap--column': false /* TOOD: get from meta */,
    }},_vm._l((_vm.data),function(word){return _c('ActivityTextButton',{key:word.id,attrs:{"bg-color":_vm.getBgColor(word)},nativeOn:{"click":function($event){return _vm.onBtnClick(word)}}},[_vm._v(" "+_vm._s(word.value)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }